/**
 * Utility per export Excel accessibile
 * Usa SheetJS (xlsx) invece di vue-json-excel per supporto tastiera completo
 */
import * as XLSX from 'xlsx'

/**
 * Esporta un array di oggetti in un file Excel (.xlsx)
 * @param {Array} data - Array di oggetti da esportare
 * @param {String} filename - Nome del file (senza estensione)
 * @param {String} sheetName - Nome del foglio Excel (default: 'Report')
 */
export function exportToExcel(data, filename, sheetName = 'Report') {
	if (!data || data.length === 0) {
		console.warn('Nessun dato da esportare')
		return
	}

	// Crea worksheet dai dati JSON
	const ws = XLSX.utils.json_to_sheet(data)
	
	// Crea workbook e aggiungi il worksheet
	const wb = XLSX.utils.book_new()
	XLSX.utils.book_append_sheet(wb, ws, sheetName)
	
	// Scarica il file
	XLSX.writeFile(wb, `${filename}.xlsx`)
}

export default { exportToExcel }
